import {Component, OnInit, AfterViewInit, Input, Output, EventEmitter} from '@angular/core';


@Component({
	selector: 'component-textarea',
	templateUrl: './component.textarea.html',
	styleUrls: ['./component.textarea.css']
})

export class ComponentTextarea implements OnInit, AfterViewInit {

  @Input() id: number; //组件唯一标识
  @Input() isShowWordLimit: boolean; //是否显示字数统计
  @Input() maxLen: number; //文本最大字数
  @Input() questionId: number; //问题ID
  @Input() textareaValue: string; //文本框内容
  @Input() placeholder: string; //placeholder
  @Input() type: number; //文本框类型
  @Output() outPutValue = new EventEmitter<any>();

  wordCount: number = 0;
  realMaxLen: number;
  exerciseScrollTop : number = 0;


  constructor() {}

  ngOnInit() {
    // this.wordCount = this.textareaValue ? this.textareaValue.length : 0;
    if(this.textareaValue){
      this.calcTextareaLen(this.textareaValue);
    }

  }

  ngAfterViewInit() {
    if(this.type == 6 || this.type == 8){//智能作业表格题默认展示
      setTimeout(()=>{
        $('#component-textarea-'+this.questionId+"-"+this.id).height($('#component-textarea-'+this.questionId+"-"+this.id)[0].scrollHeight);
      })
    }
  }

  /**
   * 计算文本框字数
   * @param e: HTMLElement | String  文本框对象 | 文本内容
   */
  calcTextareaLen(e):void{
    if(this.wordCount >= this.maxLen && e.keyCode && e.keyCode == 8){
      return;
    }else{
      // 取出回车字符
      let textareaVal = e.target  ? ($(e.target).val().replace(/<(.+?)>/gi,"&lt;$1&gt;")).replace(/\n/gi,"|") : (e.replace(/<(.+?)>/gi,"&lt;$1&gt;")).replace(/\n/gi,"|");
      // 回车数量
      let entLen = textareaVal.split('|').length-1;
      // 不包含回车的数量
      let strLen = textareaVal.split('|').join('').length;
      this.realMaxLen = this.maxLen + entLen;
      this.wordCount = strLen;
    }
  }

  // 文本框自适应高度
  autoTextarea(e,type){
    const exerciseItemWrap = document.getElementById("exercise-item-wrap-active")
    let textarea = document.getElementById(`component-textarea-${this.questionId}-${this.id}`)
    let pre = document.getElementById(`fit1-${this.questionId}-${this.id}`);
    pre.innerHTML = e.target.value;
    let realHeight = pre.offsetHeight;//offsetHeight = height + padding + border
    textarea.style.height = realHeight > 170 ? realHeight + 20 + 'px' :  realHeight + 'px'; //加20为一行的高度
    let titlteHeight = document.querySelector(".question-title").clientHeight;
    //判断是ios还是安卓
    let userAgent = navigator.userAgent.toLowerCase();
    if(this.type == 1 || this.type ==7){//文本题
      if(exerciseItemWrap){
        setTimeout(() => {
          let inpTop = realHeight + titlteHeight/2 -120 ;
          let scrollTop = realHeight > 170 ? inpTop : titlteHeight>320 ?titlteHeight/2: 80;
          let androidTop = realHeight > 180 ? (this.type== 7 ? realHeight + titlteHeight :realHeight + titlteHeight - 130) : (this.type== 7 ? 200 : titlteHeight);
          exerciseItemWrap.scrollTop = /android/i.test(userAgent)? androidTop : scrollTop;
        }, 500);
      }
    }else if(this.type == 3 || this.type ==6 || this.type == 8){//表格题
      setTimeout(() => {
      if(type == 'focus') this.exerciseScrollTop = Number(sessionStorage.getItem("exerciseScrollTop"))
        let answerStepWrap = document.getElementById(`answer-step-wrap-${this.id}`);
        let scrollTop = this.exerciseScrollTop + (answerStepWrap.offsetTop - this.exerciseScrollTop)/3 ;
        exerciseItemWrap.scrollTop = /android/i.test(userAgent)? (realHeight > 180 ? answerStepWrap.offsetTop + 60 : answerStepWrap.offsetTop + 40) : (realHeight > 170 ? scrollTop + 40 : scrollTop);
      }, 500);
    }
    this.calcTextareaLen(e);
  }

  // 将内容传输到父组件
  outPutTextareaVal(e){
    this.autoTextarea(e,'input');
    this.outPutValue.emit({
      'index': this.id,
      'questionId': this.questionId,
      'type': this.type,
      'content': $(e.target).val(),
      'wordOverrun':this.wordCount == this.maxLen
    });
  }


}



// WEBPACK FOOTER //
// ./src/component/textarea/component.textarea.ts